const lines = [
  "Maybe you connect things other people keep separate.",
  "Maybe your mind moves sideways before it moves forward.",
  "Maybe you have spent parts of your life being called too much, too curious, too chaotic, too intense, too strange or simply difficult to understand.",
];

const RecognitionSection = () => {
  return (
    <section id="recognition" className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 max-w-3xl">
        <p className="text-sm uppercase tracking-[0.2em] text-coral-text mb-6">Recognition</p>

        <h2 className="text-3xl md:text-5xl font-heading font-bold leading-tight mb-12">
          Maybe your mind doesn't travel in{" "}
          <span className="text-gradient-coral">straight lines.</span>
        </h2>

        <ul className="space-y-8 mb-14">
          {lines.map((line) => (
            <li key={line} className="flex gap-5">
              <span className="mt-3 block w-8 h-[1px] shrink-0 bg-primary/40" aria-hidden="true" />
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">{line}</p>
            </li>
          ))}
        </ul>

        <p className="text-xl md:text-2xl font-heading font-bold text-foreground mb-12">
          We call this different thinking valuable.
        </p>

        <div className="border-l-4 border-primary bg-primary/5 p-8 md:p-10">
          <p className="text-xl md:text-3xl font-heading font-bold leading-snug text-foreground">
            You do not have to prove that you are nonlinear enough to belong here.
          </p>
        </div>

        <p className="text-sm text-muted-foreground mt-8">
          No diagnoses. No IQ. No labels. No elite club.
        </p>
      </div>
    </section>
  );
};

export default RecognitionSection;